export function TownshipVsCity() {
  const jurisdictions = [
    {
      title: 'Township of Langley',
      area: 'Larger rural and suburban areas',
      population: '~132,000 residents',
      approach: 'More flexible framework',
      image: 'https://public.readdy.ai/ai/img_res/7d2912ce0a24ead3c01f19f8aa860a3f.jpg',
      features: [
        'Broader zoning permissions',
        'Rural property considerations',
        'Agricultural land exemptions',
        'Larger lot sizes typical',
        'More lenient density rules',
        'Farm-stay opportunities'
      ]
    },
    {
      title: 'City of Langley',
      area: 'Urban core municipality',
      population: '~29,000 residents',
      approach: 'Urban-focused regulations',
      image: 'https://readdy.ai/api/search-image?query=City%20of%20Langley%20downtown%20urban%20core%20with%20modern%20commercial%20buildings%20and%20residential%20towers%2C%20compact%20walkable%20city%20center%20with%20shops%20and%20amenities%2C%20clean%20urban%20development%20with%20pedestrian-friendly%20streets%2C%20professional%20cityscape%20photography%20showing%20urban%20character&width=600&height=400&seq=langley-city-001&orientation=landscape',
      features: [
        'Stricter urban zoning',
        'Higher density areas',
        'Condo and townhouse focus',
        'Walkable downtown core',
        'Transit-oriented development',
        'Mixed-use considerations'
      ]
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Township vs City: Understanding the Difference
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Langley consists of two separate municipalities with distinct regulatory approaches. Understanding which jurisdiction your property falls under is critical for compliance.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {jurisdictions.map((jurisdiction, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={jurisdiction.image}
                  alt={jurisdiction.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              </div>
              
              <div className="p-8">
                <h3 className="font-['Fraunces'] text-2xl font-bold text-[#505A5A] mb-4">
                  {jurisdiction.title}
                </h3>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-[#882629] text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-semibold text-[#505A5A]">Coverage Area</p>
                      <p className="text-sm text-[#505A5A]/70">{jurisdiction.area}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <i className="ri-group-line text-[#882629] text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-semibold text-[#505A5A]">Population</p>
                      <p className="text-sm text-[#505A5A]/70">{jurisdiction.population}</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3">
                    <i className="ri-file-list-3-line text-[#882629] text-xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
                    <div>
                      <p className="text-sm font-semibold text-[#505A5A]">Regulatory Approach</p>
                      <p className="text-sm text-[#505A5A]/70">{jurisdiction.approach}</p>
                    </div>
                  </div>
                </div>

                <div className="border-t border-[#505A5A]/10 pt-6">
                  <p className="text-sm font-semibold text-[#505A5A] mb-4">Key Characteristics:</p>
                  <ul className="space-y-2">
                    {jurisdiction.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-[#882629] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center mt-0.5"></i>
                        <span className="text-sm text-[#505A5A]/80">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-[#882629] text-3xl flex-shrink-0 w-8 h-8 flex items-center justify-center"></i>
            <div>
              <h4 className="font-semibold text-[#505A5A] text-lg mb-2">Important Note</h4>
              <p className="text-[#505A5A]/70 leading-relaxed">
                <strong>Always verify your property's jurisdiction before proceeding.</strong> The Township of Langley surrounds the City of Langley, but they are separate municipalities with different bylaws, licensing processes, and fees. Contact us for a jurisdiction verification and tailored compliance strategy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
